"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchRemovePhone = class extends Mixins(AccountSessionMixins) {
  get show() {
    return true;
  }
  multiUnbindPhone() {
    return __async(this, null, function* () {
      try {
        let _result = yield UiConfirm.prompt(
          this.$t(
            "team_management.remove_phone_bind.comfirm_dialog.message"
          ),
          this.$t(
            "team_management.remove_phone_bind.comfirm_dialog.title"
          ),
          {
            customClass: "confirm-dark",
            showCancelButton: false,
            confirmButtonText: this.$t(
              "team_management.remove_phone_bind.comfirm_dialog.confirm"
            ),
            confirmButtonClass: "btn-orange",
            roundButton: true,
            inputType: "password",
            inputPlaceholder: this.$t(
              "team_management.remove_phone_bind.comfirm_dialog.input_place_holder"
            ),
            inputPattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/,
            inputErrorMessage: this.$t(
              "team_management.remove_phone_bind.comfirm_dialog.input_error_message"
            )
          }
        );
        let result = _result;
        yield API.put(`api://base.auth/api/v1/account/user/unbindphone`, {
          password: result.value,
          user_ids: ((selectItems) => {
            let items = [];
            for (let item of selectItems) {
              items.push(item.guid);
            }
            return items;
          })(this._controller)
        });
        this.$message.success(
          this.$t(
            "team_management.remove_phone_bind.comfirm_dialog.success_message"
          )
        );
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchRemovePhone.prototype, "_controller", 2);
BatchRemovePhone = __decorateClass([
  Component
], BatchRemovePhone);
export {
  BatchRemovePhone as default
};
